export default __webpack_public_path__ + "images/onfido-logo-light_3bEB6.svg";